var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.$parent.addCard(_vm.data)}}},[_vm._v("Add")])}
var staticRenderFns = []

export { render, staticRenderFns }